export default __webpack_public_path__ + "static/media/Delete.26174035.svg";